// extracted by mini-css-extract-plugin
module.exports = {"root":"_3Fng9","RibbonsMenuButtonNSkin":"_2mFYo","ribbonsMenuButtonNSkin":"_2mFYo","linkElement":"_2geYv","wrapper":"bkGLO","label":"_1F6mo"};